import { render, staticRenderFns } from "./btnImportar.vue?vue&type=template&id=2ce87e2d&"
import script from "./btnImportar.vue?vue&type=script&lang=js&"
export * from "./btnImportar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports